import { render, staticRenderFns } from "./UALineChart.vue?vue&type=template&id=127638c6"
import script from "./UALineChart.vue?vue&type=script&lang=js"
export * from "./UALineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports